export enum KsefDocumentSendingError {
    DocumentAlreadyProcessed = 'DocumentAlreadyProcessed',
    InvalidVersion = 'InvalidVersion',
    DocumentAlreadyInitialized = 'DocumentAlreadyInitialized',
    DocumentNotFound = 'DocumentNotFound',
    KsefDocumentNotFound = 'KsefDocumentNotFound',
    KsefIsDisabled = 'KsefIsDisabled',
    DocumentIsTraditional = 'DocumentIsTraditional'
}
